import React from 'react'
import PropTypes from 'prop-types'
import { compose, pure } from 'recompose'

import TextLabel, { SizeType } from '../../atoms/TextLabel/TextLabel'
import { formatTime } from '../../../../commons/viewHelper'
import './QuizScore.css'

const QuizScore = ({ correctCount, time }) => (
  <div styleName="container">
    <div styleName="l-correct">
      <TextLabel size={SizeType.LARGE}>{`${correctCount}問正解`}</TextLabel>
    </div>
    <div styleName="l-time">
      <TextLabel size={SizeType.LARGE}>{`${formatTime(time)}秒`}</TextLabel>
    </div>
  </div>
)

QuizScore.propTypes = {
  correctCount: PropTypes.number.isRequired,
  time: PropTypes.number.isRequired
}

export default compose(pure)(QuizScore)
